import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function CareerProgress() {

  const [progress, setProgress] = useState({
    resumesCreated: 0,
    resumeCritiques: 0,
    interviews: 0,
    communityPosts: 0
  });

  useEffect(() => {

    const fetchProgress = async () => {

      const user = auth.currentUser;
      if (!user) return;

      const ref = doc(db, "users", user.uid);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const data = snap.data();
        if (data.progress) {
          setProgress(data.progress);
        }
      }
    };

    fetchProgress();

  }, []);

  return (
    <div className="progress-card">

      <h3>Career Progress</h3>

      <div className="progress-item">
        <span>Resumes Created</span>
        <strong>{progress.resumesCreated}</strong>
      </div>

      <div className="progress-item">
        <span>Resume Critiques</span>
        <strong>{progress.resumeCritiques}</strong>
      </div>

      <div className="progress-item">
        <span>Interview Practice</span>
        <strong>{progress.interviews}</strong>
      </div>

      <div className="progress-item">
        <span>Community Activity</span>
        <strong>{progress.communityPosts}</strong>
      </div>

    </div>
  );
}

export default CareerProgress;